import { useParams } from "react-router-dom";
import { postsForRoute } from "@/blog/data";
import { SHOW_SISTEMA_LUCENTIA } from "@/config/features";
import { useReadArticles } from "@/blog/readHistory";
import { BLOG_ROUTES, blogRoutePath } from "@/blog/routes";
import { BlogCtaBand } from "@/components/blog/BlogCtaBand";
import { RouteSteps } from "@/components/blog/RouteSteps";
import { TextLink } from "@/components/ui/Button";
import { PageHero } from "@/components/ui/PageHero";
import { usePageSeo } from "@/hooks/usePageSeo";
import { NotFoundPage } from "@/pages/NotFoundPage";

export function BlogRoutePage() {
  const { routeId } = useParams();
  const route = BLOG_ROUTES.find((item) => item.id === routeId);
  const posts = route ? postsForRoute(route.id) : [];
  if (!route || posts.length === 0) return <NotFoundPage />;
  return <RouteView routeId={route.id} />;
}

function RouteView({ routeId }: { routeId: (typeof BLOG_ROUTES)[number]["id"] }) {
  const route = BLOG_ROUTES.find((item) => item.id === routeId)!;
  const posts = postsForRoute(route.id);
  const read = useReadArticles();
  usePageSeo(blogRoutePath(route.id));
  const minutes = posts.reduce((sum, post) => sum + post.readingMinutes, 0);
  const others = BLOG_ROUTES.filter((item) => item.id !== route.id && postsForRoute(item.id).length > 0);

  return (
    <main id="main-content" tabIndex={-1} className="outline-none">
      <PageHero
        crumb={`Ruta ${route.label}`}
        trail={[{ label: "Blog", to: "/blog" }]}
        title={route.title}
        lead={
          <>
            <p>{route.description}</p>
            <p className="mt-3 text-base font-semibold text-teal-strong">
              {posts.length} {posts.length === 1 ? "artículo" : "artículos"} · {minutes} min de lectura en total
            </p>
          </>
        }
      />

      <section aria-label={`Artículos de la ${route.title.split(":")[0]}`} className="mx-auto max-w-7xl px-4 pb-16 sm:px-6 lg:px-8">
        <div className="max-w-4xl">
          <RouteSteps posts={posts} read={read} detailed headingLevel="h2" />
          <div className="mt-10 flex flex-col gap-4 border-t border-brand-primary/10 pt-8 sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-8">
            {SHOW_SISTEMA_LUCENTIA || route.service.to !== "/metodo" ? (
              <TextLink to={route.service.to}>Conocé {route.service.label}</TextLink>
            ) : null}
            {others.map((item) => (
              <TextLink key={item.id} to={blogRoutePath(item.id)}>
                Ruta {item.label}
              </TextLink>
            ))}
          </div>
        </div>
      </section>

      <BlogCtaBand cta="audit" location="blog_route" />
    </main>
  );
}
